import revive_payload_client_4sVQNw7RlN from "/var/www/frontend/html/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/frontend/html/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/frontend/html/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/frontend/html/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/frontend/html/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/frontend/html/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/frontend/html/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/var/www/frontend/html/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/var/www/frontend/html/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/frontend/html/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import floating_vue_EIcJ7xiw0h from "/var/www/frontend/html/.nuxt/floating-vue.mjs";
import gsapPlugin_HlwIIyl85L from "/var/www/frontend/html/.nuxt/gsapPlugin.mjs";
import _0_auth_vlz2207QBX from "/var/www/frontend/html/backend/plugins/0.auth.ts";
import gtag_client_Zw8EQXNVTz from "/var/www/frontend/html/plugins/gtag.client.ts";
import maska_UHaKf2z1iQ from "/var/www/frontend/html/plugins/maska.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  floating_vue_EIcJ7xiw0h,
  gsapPlugin_HlwIIyl85L,
  _0_auth_vlz2207QBX,
  gtag_client_Zw8EQXNVTz,
  maska_UHaKf2z1iQ
]